import React from 'react';
import ReffereSummarry from './ReffereSummarry';
import RefererLinkorCode from './RefererLinkorCode';
import AllReferer from './AllReferer';
import WithdrawalHistory from './WithdrawalHistory';

function Referer() {
  return (
    <>
      <div className='my-8 mx-6 flex flex-col gap-10 '>
        <ReffereSummarry />
        <RefererLinkorCode />
        <div className='w-full flex flex-col md:flex-row gap-6 items-start'>
          <AllReferer />
          <WithdrawalHistory />
        </div>
      </div>
    </>
  );
}

export default Referer;
